import { COLORS } from '@btime/constants'
import { fromNow } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { SmallText, Text } from '../../../../components/presentation/Text'
import { formatRunningTime } from '../../../../utils/helpers/date'
import { translateLog } from '../../_locales/logKeyGenerator'
import { useLogs } from '../_load/LogsListLoader'
import { useOpenLogModal } from '../../../../utils/routes/modals/modalsActions'
import { useRowActionsColumn } from '../../../../components/tables/Table'
import { useRowsActions } from './_actions/rowsActions'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import EntityPresenter from '../../_shared/EntityPresenter'
import LevelTag from '../../_shared/LevelTag'
import Link from '../../../../components/actions/Link'
import OriginTag from '../../_shared/OriginTag'
import UserPresenter from '../../../../containers/users/UserPresenter'

const LogsTable = () => {
  const { t } = useTranslation(['listLogs', 'common'])

  const { list: data } = useLogs()
  const openDetailsModal = useOpenLogModal()

  const columns = [
    {
      label: t('name'),
      dataIndex: 'name',
      flex: 6,
      render: (value, record) => (
        <Link onClick={() => openDetailsModal(record)} block>
          <Text color={COLORS.dark2} breakWord bold={false}>
            {translateLog(t, record)}
          </Text>
          <SmallText color={COLORS.dark3} breakWord size="xxsmall">
            key: {value}
          </SmallText>
        </Link>
      )
    },

    {
      label: t('origin'),
      dataIndex: 'origin',
      flex: 1,
      render: value => <OriginTag origin={value} />
    },

    {
      label: t('level'),
      dataIndex: 'level',
      flex: 1,
      render: value => <LevelTag level={value} />
    },

    {
      label: t('affectedEntities'),
      dataIndex: 'entity',
      flex: 3,
      render: (value, record) => (
        <EntityPresenter
          entity={value}
          entities={record.entities}
          hideIcon
          hideAvatar
          color={COLORS.dark3}
          fontSize="small"
          hideEmptyMessage
          breakWord
        />
      )
    },

    {
      label: t('user'),
      dataIndex: 'user',
      flex: 2,
      render: value => (
        <UserPresenter
          user={value}
          hideIcon
          hideAvatar
          color={COLORS.dark3}
          fontSize="small"
          hideEmptyMessage
          breakWord
        />
      )
    },

    {
      label: t('time'),
      dataIndex: 'executionTime',
      flex: 1,
      format: formatRunningTime
    },

    {
      label: t('date'),
      dataIndex: 'happenedAt',
      flex: 1.5,
      format: fromNow
    },

    {
      label: t('common:actions'),
      flex: 1,
      render: useRowActionsColumn(useRowsActions)
    }
  ]

  return <DataTable rowKey="id" columns={columns} size="medium" data={data} inPanel />
}

export default LogsTable
